import React from 'react';
import { IControllerType } from '@/redux/post/post.d';
import Onefinity from '@/components/Icons/Onefinity';
import Redline from '@/components/Icons/Redline';
import Masso from '@/components/Icons/Masso';

export interface IControllerConfig {
  type: IControllerType;
  name: string;
  initial: string;
  icon?: React.ComponentType<{ className?: string }>;
  allowedFileTypes: string[];
  acceptString: string;
}

export const CONTROLLER_CONFIG: Record<IControllerType, IControllerConfig> = {
  [IControllerType.REDLINE]: {
    type: IControllerType.REDLINE,
    name: 'Redline',
    initial: 'R',
    icon: Redline,
    allowedFileTypes: ['.gcode', '.ngc', '.nc', '.gc'],
    acceptString: '.gcode,.ngc,.nc,.gc',
  },
  [IControllerType.MASSO]: {
    type: IControllerType.MASSO,
    name: 'Masso',
    initial: 'M',
    icon: Masso,
    allowedFileTypes: ['.gcode', '.nc', '.gc'],
    acceptString: '.gcode,.nc,.gc',
  },
  [IControllerType.BUILDOTICS]: {
    type: IControllerType.BUILDOTICS,
    name: 'Buildbotics',
    initial: 'B',
    icon: Onefinity,
    allowedFileTypes: ['.ngc'],
    acceptString: '.ngc',
  },
  [IControllerType.OTHER]: {
    type: IControllerType.OTHER,
    name: 'Other',
    initial: 'O',
    allowedFileTypes: ['.gcode', '.ngc', '.nc', '.gc'],
    acceptString: '.gcode,.ngc,.nc,.gc',
  },
};

// ponytail: OTHER intentionally omitted — hidden from the upload UI (checkboxes/tabs/detection).
// CONTROLLER_CONFIG keeps OTHER as the enum's detection fallback; re-add the line to surface it again.
export const CONTROLLER_ORDER: IControllerType[] = [
  IControllerType.REDLINE,
  IControllerType.MASSO,
  IControllerType.BUILDOTICS,
];

export const validateFileForController = (
  fileName: string,
  controller: IControllerType
): boolean => {
  const config = CONTROLLER_CONFIG[controller];
  const fileExtension = fileName
    .toLowerCase()
    .substring(fileName.lastIndexOf('.'));
  return config.allowedFileTypes.includes(fileExtension);
};
